import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useEffect } from 'react';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { InnerhivePlusDialogViewModel, ITriggerPaywallSource } from './InnerhivePlusDialogViewModel';

export const PaywallTriggerHandler: React.FC = () => {

    const history = useInstance(HistoryViewModel);
    const paywall = useInstance(InnerhivePlusDialogViewModel);

    useEffect(() => {
        // if guest triggers paywall, they are sent to login with this query params in the returnTo url
        const paywallTrigger = history.popSearchParam({ key: 'paywallTrigger' }) as ITriggerPaywallSource;

        if (paywallTrigger) {
            paywall.resume({ triggerSource: paywallTrigger });
        }

    }, [history, paywall]);

    return null;
};
